import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

/**
 * Shared "Notes" textarea — identical between Add and Edit save flows.
 */
export function SegmentNotesField({ segment, onChange, testIdPrefix = "segment" }) {
  return (
    <div className="grid gap-2">
      <Label htmlFor="notes">Notes</Label>
      <Textarea
        id="notes"
        data-testid={`${testIdPrefix}-notes-input`}
        placeholder="Additional details..."
        value={segment.notes || ""}
        onChange={(e) => onChange({ notes: e.target.value })}
        rows={3}
      />
    </div>
  );
}

export default SegmentNotesField;
